module.exports = "/images/sorting-desc.svg?d60330d44d0d6dcf8fb44a174b9becfb";